import {colorStyleMap} from '@/utilities/color-style-map';
import classNames from 'classnames';
import register from 'preact-custom-element';

export default CheckboxIcon;
register(CheckboxIcon, 'checkbox-icon', ['color', 'onInput']);

/**
 * An SVG icon which overrides the default checkbox. This allows us to
 * show a consistent branded checkbox across browsers.
 * @param props - the props
 * @returns - the checkbox icon
 */
function CheckboxIcon({
  checked = true,
  color = 'primary-blue',
}: CheckboxIconProps) {
  const colorStyle = colorStyleMap.get(color);
  const stroke = colorStyle?.stroke ?? 'stroke-primary-blue';
  const fill = colorStyle?.fill ?? 'fill-primary-blue';

  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="16"
        height="16"
        rx="3"
        className={classNames(' fast-transition ', {
          'fill-bright-white hover:fill-bright-white-hover active:fill-bright-white-active':
            !checked,
          [fill]: checked,
        })}
      />
      {checked && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6402 4.7318C13.0645 5.08537 13.1218 5.71593 12.7682 6.14021L7.76825 12.1402C7.41468 12.5645 6.78412 12.6218 6.35984 12.2682L3.35984 9.76825C2.93556 9.41468 2.87824 8.78412 3.2318 8.35984C3.58537 7.93556 4.21593 7.87824 4.64021 8.2318L6.87199 10.0916L11.2318 4.85984C11.5854 4.43556 12.2159 4.37824 12.6402 4.7318Z"
          className={'fill-bright-white'}
        />
      )}
      <rect
        x="0.75"
        y="0.75"
        width="14.5"
        height="14.5"
        rx="2.25"
        strokeWidth="1.5"
        className={stroke}
      />
    </svg>
  );
}

/**
 * The props for the checkbox icon.
 * @param checked - whether the checkbox is checked
 * @param color - the color
 */
type CheckboxIconProps = {
  checked?: boolean;
  color?: string;
};
